// extracted by mini-css-extract-plugin
export var hero = "zKL_IehhK8rKB3X7V3w3";
export var root = "e2H_QQAAGu49wu6ABlN5";
export var title1 = "pv_X3JcAT_RvSOlbrJzd";
export var title2 = "INIXTigEVjK2cF3meKZ6";
export var title3 = "CUBXftM8FN192lesaqd2";